export default {
  data() {
    return {
      r: {
        NOT_FOUND: '-',
        config: {
          reportType: 'group',
          showEmptyUsers: false,
          assignmentsEnabled: null,
        },
        data: {
          csvHeaders: [],
          csvBody: [],
        }
      },
    };
  },
  computed: {
    vibes() {
      return this.$store.getters.appConfig.vibes;
    },
    myGroupsHeaders() {
      const isGroupManager = (this.selectedGroup && this.selectedGroup.roles && this.selectedGroup.roles.indexOf('manager') !== -1);
      if (!isGroupManager) {
        return [
          'Number of Recordings Shared with Peers',
          'Total Length of Shared Recordings',
          'Last Shared Recording'
        ];
      } else if (isGroupManager && this.selectedGroup.managerPrivacyLevel >= 3) {
        return [
          'Number of Recordings Shared with You',
          'Total Length of Shared Recordings',
          'Last Shared Recording'
        ];
      }
      return [
        'Number of Recordings',
        'Total Length of Recordings',
        'Last Recording'
      ];
    },
  },
  methods: {
    setReportConfig() {
      let assignmentsEnabled = false;
      this._.map(this.speakers, (speaker) => {
        if (speaker.assignments) {
          assignmentsEnabled = true;
        }
      });

      this.r.config.assignmentsEnabled = this.r.config.reportType === 'assignment' ?
        true : assignmentsEnabled;
    },

    preDownloadReport() {
      // Next see if we can render the report or if we need to fetch feedback
      let promises = [];

      if (!this.dataLoaded) {
        promises.push(this.$store.dispatch('listGroupFeedback'));
      }

      if (promises.length) {
        window.Promise.all(promises).then(() => {
          this.dataLoaded = true;
          this.downloadReport();
        });
        return true;
      }
      this.downloadReport();
    },

    setCsvHeaders() {
      const flagged = (this.r.config.assignmentsEnabled) ? 'Flagged for Review' : 'User-Submitted';
      let csvHeaders =
          [
            'Speaker', 'Created Date', 'Title', 'Duration (seconds)', flagged, 'Vocal Delivery (automated)',
            'Strength of Opening', 'Clarity', 'Pace Variation', 'Pitch Variation',
            'Pace (syllables per second)', 'Pace', 'Pausing',
            'Upspeak', '"""Um/Uh"" Count"', '"""Like"" Count"', 'Variety of Pace (Old)',
            'Variety of Pitch (Old)', 'Variety of Volume', 'Reading',
          ];

      if (this.r.config.assignmentsEnabled) {
        csvHeaders.splice(1, 0, 'Assignment Name', 'Assignment Status for Speaker');
      }

      // Build the full headers row
      csvHeaders = csvHeaders.concat(this.vibes);

      if (this.r.config.reportType === 'assignment') {
        this._.forEach(this.scorecardQuestionsForAssignment, (score) => {
          csvHeaders = csvHeaders.concat(['Rating: ' + score.label]);
        });
        csvHeaders = csvHeaders.concat(['Number of Raters']);
        this._.forEach(this.scorecardQuestionsForAssignment, (score) => {
          csvHeaders = csvHeaders.concat(['Coach Ratings: ' + score.label]);
        });
        csvHeaders = csvHeaders.concat(['Number of Coach Raters']);
      } else {
        csvHeaders = csvHeaders.concat(['Rating: Overall', 'Rating: Organization & Content', 'Rating: Delivery', 'Rating: X-Factor', 'Number of Raters']);
        csvHeaders = csvHeaders.concat(['Coach Ratings: Overall', 'Coach Ratings: Organization & Content', 'Coach Ratings: Delivery', 'Coach Ratings: X-Factor', 'Number of Coach Raters']);
      }
      csvHeaders = csvHeaders.concat(['Feedback Count', 'Feedback']);

      this.r.data.csvHeaders = csvHeaders;
    },

    downloadReport() {
      this.setReportConfig();
      this.setCsvHeaders();
      this.setCsvBody();

      const csv = this.r.data.csvHeaders.join(',') + "\r\n" + this.r.data.csvBody; // eslint-disable-line quotes
      const currDate = '_' + this.moment().format('l').replace(/\W/g, '_');
      const filename = (this.r.config.reportType === 'group') ?
        'Report_for_' + this.selectedGroup.name.replace(/\W/g, '_') + currDate + '.csv' :
        'Report_for_' + this.assignment.name.replace(/\W/g, '_') + currDate + '.csv';
      window.download(csv, filename, 'application/csv');
    },

    setCsvBody() {
      const sortedSpeakers = this._.sortBy(
        this.speakers,
        speaker => speaker.lastName.toUpperCase(), speaker => speaker.firstName.toUpperCase()
      );

      let csvBody = '';
      this._.map(sortedSpeakers, (speaker) => {
        let recordings = [];
        if (speaker.assignments) {
          this._.map(speaker.assignments, (ass) => {
            if (ass.recordings && ass.recordings.length) {
              ass.recordings.forEach((r) => {
                r.assignmentName = ass.name;
                r.assignmentStatus = ass.completionStatus.status;
                if (this.r.config.reportType === 'group' ||
                  (this.r.config.reportType === 'assignment' && ass.assignmentId === this.assignment.assignmentId)) {
                  recordings.push(r);
                }
              });
            } else if (this.r.config.showEmptyUsers) {
              // They haven't uploaded any recordings for this assignment yet
              // so push in a dummy recording
              recordings.push({
                isPlaceholder: true,
                assignmentName: ass.name,
                assignmentStatus: ass.completionStatus.status,
              });
            }
          });
          recordings = this._.sortBy(recordings, (r) => -new Date(r.createdDate).getTime());
        } else {
          recordings = speaker.recordings;
        }

        if (recordings.length) {
          this._.forEach(recordings, (recording) => {
            if (recording.isPlaceholder) {
              // Add placeholder entry
              csvBody += speaker.name + ',' + recording.assignmentName + ',' + recording.assignmentStatus;
              for (let i = 1; i < this.r.data.csvHeaders.length - 2; i++) {
                csvBody += ',' + this.r.NOT_FOUND;
              }
              csvBody += "\r\n"; // eslint-disable-line quotes
            } else {
              csvBody += this.getRecordingCsv(recording, speaker);
            }
          });
        } else if (this.r.config.showEmptyUsers && this.r.config.reportType === 'assignment') {
          // Add placeholder entry
          const assignmentName = this.assignment ? this.assignment.name : recording.assignmentName;
          const assignmentStatus = speaker.completionStatus ?
            speaker.completionStatus.status :
            recording.assignmentStatus;

          csvBody += speaker.name + ',' + assignmentName + ',' + assignmentStatus;
          for (let i = 1; i < this.r.data.csvHeaders.length - 2; i++) {
            csvBody += ',' + this.r.NOT_FOUND;
          }
          csvBody += "\r\n"; // eslint-disable-line quotes
        } else if (this.r.config.showEmptyUsers) {
          // Add placeholder entry for students with no recs
          csvBody += speaker.name;
          for (let i=1; i<this.r.data.csvHeaders.length; i++) {
            csvBody += ',' + this.r.NOT_FOUND;
          }
          csvBody += "\r\n"; // eslint-disable-line quotes
        }
      });
      this.r.data.csvBody = csvBody;
    },

    escapeData(item) {
      item = item + ''; // cast item to a string
      if (item.match(/[,"\n]/)) {
        item = '"' + item.replace(/\"/g, "\"\"") + '"'; // eslint-disable-line quotes
      }
      return item;
    },

    getScore(rec, score) {
      if (!rec.results || !rec.results.scores) {
        return this.r.NOT_FOUND;
      }
      return (typeof rec.results.scores[score] !== 'undefined') ?
        rec.results.scores[score] : this.r.NOT_FOUND;
    },

    getVibe(rec, vibe) {
      if (!rec.results || !rec.results.scores || !rec.results.scores.vibes) {
        return this.r.NOT_FOUND;
      }
      return (typeof rec.results.scores.vibes[vibe] !== 'undefined') ?
        rec.results.scores.vibes[vibe] : this.r.NOT_FOUND;
    },

    /**
     * Returns scores for both varietyPitch and pitchVariation;
     * varietyPace and paceVariation; and varietyVolume.
     * @param recording
     * @param scoreName
     * @param attr Pass in "value" for pitchVariation and paceVariation
     * @returns {*}
     */
    getVarietyScore(rec, scoreName, attr=null) {
      const LABELS = ['Too little', 'Ideal', 'Too much'];
      const score = this.getScore(rec, scoreName);
      if (score === this.r.NOT_FOUND) {
        return this.r.NOT_FOUND;
      }
      if (attr) {
        return (score[attr]) ? score[attr] : this.r.NOT_FOUND;
      }
      if (score.inBand >= score.belowBand && score.inBand >= score.aboveBand) {
        return LABELS[1]; // ideal
      } else if (score.belowBand >= score.inBand && score.belowBand >= score.aboveBand) {
        return LABELS[0]; // too low
      }
      return LABELS[2]; // too high
    },

    getReadingScore(rec) {
      const reading = this.getScore(rec, 'reading');
      return (reading === this.r.NOT_FOUND) ? this.r.NOT_FOUND :
        (reading >= 50) ? 'Yes' : 'No';
    },

    getAdjustedScore(rec, scoreName) {
      const LABELS = {
        pace: ['Too slow', 'Ideal', 'Too fast'],
        pauseToTalk: ['Too little', 'Ideal', 'Too much'],
        upspeak: ['None', 'Some', 'Too much'],
      };

      const score = this.getScore(rec, scoreName);
      if (score === this.r.NOT_FOUND) {
        return this.r.NOT_FOUND;
      }

      const idealMin = rec.results.ideals[scoreName].range.idealMin;
      const idealMax = rec.results.ideals[scoreName].range.idealMax;

      if (score >= idealMin && score <= idealMax) {
        return LABELS[scoreName][1]; // ideal
      } else if (score < idealMin) {
        return LABELS[scoreName][0]; // too low
      }
      return LABELS[scoreName][2]; // too high
    },

    formatDate(_date) {
      if (!_date) {
        return this.r.NOT_FOUND;
      }
      return this.moment(_date).format('lll');
    },

    getWordspotting(rec, phrase) {
      if (rec.results.scores &&
        rec.results.scores.wordSpotting &&
        phrase in rec.results.scores.wordSpotting) {
        return rec.results.scores.wordSpotting[phrase];
      }
      return this.r.NOT_FOUND;
    },

    getRecordingCsv(rec, speaker) {
      if (!rec.results || !rec.results.algorithm) {
        return ''; // ignore recordings that weren't successful
      }

      let cols =
        [
          speaker.name,
          this.formatDate(rec.createdDate),
          rec.title,
          Math.round(rec.duration),
          (rec.submitted) ? 'Yes' : 'No',
          this.getScore(rec, 'overall'),
          this.getScore(rec, 'strengthOfOpening'),
          this.getScore(rec, 'clarity'),
          this.getVarietyScore(rec, 'varietyPace', 'value'),
          this.getVarietyScore(rec, 'varietyPitch', 'value'),
          this.getScore(rec, 'pace'),
          this.getAdjustedScore(rec, 'pace'),
          this.getAdjustedScore(rec, 'pauseToTalk'),
          this.getAdjustedScore(rec, 'upspeak'),
          this.getWordspotting(rec, 'uh/um'),
          this.getWordspotting(rec, 'like'),
          this.getVarietyScore(rec, 'varietyPace'),
          this.getVarietyScore(rec, 'varietyPitch'),
          this.getVarietyScore(rec, 'varietyVolume'),
          this.getReadingScore(rec),
        ];

      // Add in the info about the assignment
      if (this.r.config.assignmentsEnabled) {
        const assignmentName = this.assignment ?
          this.assignment.name : rec.assignmentName;
        const assignmentStatus = rec.assignmentStatus ?
          rec.assignmentStatus : speaker.completionStatus.status;

        cols.splice(1, 0, assignmentName, assignmentStatus);
      }

      // Add in all the vibes
      this.vibes.forEach((vibe) => cols.push(this.getVibe(rec, vibe.toLowerCase())));

      // Add in the scores/ratings
      const ratings = this.getRatings(rec);
      ratings.ratings.forEach((rating) => {
        cols.push(rating.value || this.r.NOT_FOUND);
      });
      cols.push(ratings.numberRaters);

      ratings.managerRatings.forEach((rating) => {
        cols.push(rating.value || this.r.NOT_FOUND);
      });
      cols.push(ratings.numberManagerRaters);

      // Add in the feedback
      const feedback = this.getFeedback(rec);
      cols.push(feedback.feedbackCount);
      cols.push(feedback.feedbackText);

      // Return the results
      return this._.map(cols, this.escapeData).join(',') + "\r\n"; // eslint-disable-line quotes
    },

    getFeedback(rec) {
      let feedbackCount = 0;
      let feedbackText = '';
      const feedbacks = rec.feedback ? rec.feedback :
        this.feedback[rec.recordingId] ?
          this.feedback[rec.recordingId] : [];

      this._.each(feedbacks, (feedback) => {
        if (feedback.comment) {
          feedbackCount++;
          feedbackText += feedback.comment + "\n\n"; // eslint-disable-line quotes
        }
      });

      if (feedbackText === '') {
        feedbackText = this.r.NOT_FOUND;
      }
      return { feedbackCount, feedbackText };
    },

    getRatings(rec) {
      if (this.r.config.reportType === 'assignment') {
        let numberRaters = 0,
          numberManagerRaters = 0,
          ratings = [],
          managerRatings = [];

        this._.forEach(this.scorecardQuestionsForAssignment, (score) => {
          let recording = score.recordings ? score.recordings[rec.recordingId] : null;
          if (!recording) {
            recording = {
              avgScore: 0,
              mgrAvgScore: 0,
              responses: [],
              mgrResponses: [],
            };
          }

          ratings.push({id: score.id, value: recording.avgScore});
          managerRatings.push({id: score.id, value: recording.mgrAvgScore});
          if (recording.responses.length > numberRaters) numberRaters = recording.responses.length;
          if (recording.mgrResponses.length > numberManagerRaters) numberManagerRaters = recording.mgrResponses.length;
        });

        return { numberRaters, ratings, numberManagerRaters, managerRatings };
      }

      let numberRaters = 0,
        numberManagerRaters = 0,
        ratings = [
          {id: 'scoreOverall', value: 0},
          {id: 'scoreOrganization', value: 0},
          {id: 'scoreDelivery', value: 0},
          {id: 'scoreXfactor', value: 0},
        ],
        managerRatings = [
          {id: 'scoreOverall', value: 0},
          {id: 'scoreOrganization', value: 0},
          {id: 'scoreDelivery', value: 0},
          {id: 'scoreXfactor', value: 0},
        ];

      if (typeof this.feedback[rec.recordingId] !== 'undefined') {
        this._.each(this.feedback[rec.recordingId], (feedback) => {
          if (feedback.scoreOverall) {
            numberRaters++;
            ratings[0].value += parseFloat(feedback.scoreOverall || 0);
            ratings[1].value += parseFloat(feedback.scoreOrganization || 0);
            ratings[2].value += parseFloat(feedback.scoreDelivery || 0);
            ratings[3].value += parseFloat(feedback.scoreXfactor || 0);

            if (feedback.isManager) {
              numberManagerRaters++;
              managerRatings[0].value += parseFloat(feedback.scoreOverall || 0);
              managerRatings[1].value += parseFloat(feedback.scoreOrganization || 0);
              managerRatings[2].value += parseFloat(feedback.scoreDelivery || 0);
              managerRatings[3].value += parseFloat(feedback.scoreXfactor || 0);
            }
          }
        });

        if (numberRaters && ratings[0].value) {
          ratings[0].value = Math.round(ratings[0].value / numberRaters * 100) / 100;
          ratings[1].value = Math.round(ratings[1].value / numberRaters * 100) / 100;
          ratings[2].value = Math.round(ratings[2].value / numberRaters * 100) / 100;
          ratings[3].value = Math.round(ratings[3].value / numberRaters * 100) / 100;
        }
        if (numberManagerRaters && managerRatings[0].value) {
          managerRatings[0].value = Math.round(managerRatings[0].value / numberManagerRaters * 100) / 100;
          managerRatings[1].value = Math.round(managerRatings[1].value / numberManagerRaters * 100) / 100;
          managerRatings[2].value = Math.round(managerRatings[2].value / numberManagerRaters * 100) / 100;
          managerRatings[3].value = Math.round(managerRatings[3].value / numberManagerRaters * 100) / 100;
        }
      }

      return { numberRaters, ratings, numberManagerRaters, managerRatings };
    },

  }
};
